import { render, staticRenderFns } from "./InitStoreDialog.vue?vue&type=template&id=540ad131&scoped=true&"
import script from "./InitStoreDialog.vue?vue&type=script&lang=ts&"
export * from "./InitStoreDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InitStoreDialog.vue?vue&type=style&index=0&id=540ad131&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ad131",
  null
  
)

export default component.exports